// extracted by mini-css-extract-plugin
module.exports = {"headingStyle":"QuickTour_headingStyle__2Be1j"};